module.exports = "<div class=\"container-fluid nopadding\">\r\n\t\r\n<div class=\"content-wrapper\">\r\n\t<echexpayment-invoice></echexpayment-invoice>\r\n\t\t \r\n</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/admininvoice/admininvoice.component.html
// module id = ../../../../../src/app/admininvoice/admininvoice.component.html
// module chunks = main